<template>
	<div class="row">
		<load v-if="load" mode="table" class="mt-3" message="Carregando unidades" />
		<div v-else class="col-md-12">
			<input
				type="text"
				class="form-control"
				v-model="search"
				placeholder="Pesquise por uma unidade para ter a lista de contatos"
			/>
			<div style="height: 75vh; overflow: auto" class="mt-2">
				<ul class="unidades-list">
					<li
						v-for="unidade in filterUnidade"
						:key="unidade.id"
						@click="selectUnidade(unidade)"
						class="user-list py-2 px-2 d-block"
						:class="{ selected: unidade == selected }"
					>
						<div class="d-flex flex-row justify-content-between">
							<div class="unidade">
								<span class="unread" v-if="unidade.unread && unidade.unread > 0">{{
									unidade.unread
								}}</span>
								<b class="name">{{ unidade.nome }}</b>
							</div>
							<div class="nav-profile-img">
								<span v-for="unidadeID in userUnidadeOnline" :key="unidadeID">
									<span v-if="unidadeID == unidade.id" class="availability-status online">
										<i class="fa fa-circle" aria-hidden="true"></i>
									</span>
								</span>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import UnidadeList from "./includes/UnidadeList";
export default {
	components: { UnidadeList },
	props: {
		unidades: {
			type: Array,
			default: [],
		},
		load: { type: Boolean, default: true },
	},
	data() {
		return {
			selected: this.unidades.length ? this.unidades[0] : null,
			search: "",
			loadUnidade: true,
			unidadesList: [],
		};
	},
	methods: {
		selectUnidade(unidade) {
			this.selected = unidade;
			localStorage.setItem("unidade-chat-selected", unidade.id);
			this.$emit("selected", unidade.id);
		},
	},
	watch: {
		unidades() {
			this.unidadesList = this.unidades;
		},
	},
	mounted() {
		this.unidadesList = this.unidades;
	},
	computed: {
		unidadesOnline() {
			return this.unidadesList.filter((unidade) => {
				var online = this.$store.state.users.filter((u) => {
					if (unidade.id == u.unidadeID && u.unidadeID == this.unidadeid) {
						return u;
					}
				});

				var is_online = online[0] ? true : false;

				if (is_online && this.selected && unidade.id != this.selected.unidade_id) {
					return unidade;
				}
			});
		},
		unidadesOffline() {
			return this.unidadesList.filter((unidade) => {
				var online = this.$store.state.users.filter((u) => {
					if (unidade.id == u.unidadeID && u.unidadeID == this.unidadeid) {
						return u;
					}
				});

				var is_online = online[0] ? true : false;

				if (!is_online && this.selected && unidade.id != this.selected.unidade_id) {
					return unidade;
				}
			});
		},
		sortedUnidades() {
			return this.unidadesList
				.map((unidade, index) => ({ unidade, index }))
				.sort((a, b) => {
					const aUnread = Number(a.unidade.unread || 0) > 0;
					const bUnread = Number(b.unidade.unread || 0) > 0;

					if (aUnread !== bUnread) {
						return aUnread ? -1 : 1;
					}

					// Preserva a ordem recebida, inclusive a promoção da mensagem mais recente.
					return a.index - b.index;
				})
				.map(({ unidade }) => unidade);
		},
		filterUnidade() {
			return this.sortedUnidades.filter((unidade) => {
				return unidade.nome.toUpperCase().includes(this.search.toUpperCase());
			});
		},
		userUnidadeOnline() {
			return [...new Set(this.$store.state.users.map((item) => item.unidadeID))];
		},
	},
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}
.unread {
	background: #fb8994;
	color: #fff;
	right: 11px;
	min-width: 20px;
	/* top: 20px; */
	align-items: center;
	line-height: 20px;
	font-size: 12px;
	padding: 0 4px;
	/* float: right; */
	z-index: 1010;
	/* position: absolute; */
	text-align: center;
	border-radius: 10px;
}
.unidades-list {
	flex: 2;
	overflow: auto;
	list-style: none;
	padding: 0;
	margin: 0;
}
.unidade:hover {
	color: #0d5a9e;
}
.availability-status {
	font-size: 8px;
}
.availability-status.online {
	color: #1bcfb4;
}
.availability-status .offline {
	background: #ccc;
}
.user-list {
	/* min-height: 50px; */
	border-bottom: 1px solid #eaeaea;
}
.user-list:hover {
	cursor: pointer;
	background: #f4f4f4;
}
</style>
